/*
 * @Author: 郭德纲
 * @Date: 2020-11-10 16:35:41
 * @LastEditors: 郭德纲
 * @LastEditTime: 2020-12-19 17:20:09
 * @Description: 请求拦截
 */
/** **   request.js   ****/
import axios from 'axios';
import Vue from 'vue'
import { message } from 'ant-design-vue'
Vue.use(message)
let index = [];
const service = axios.create({
  timeout: 3 * 1000,
  baseURL: 'https://api.moshouapp.com',

});
service.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type': 'application/json', // 请求发送的格式
      'accept': 'application/json', // 需要接收的形式
      'X-LC-Id': 'QoccwmtjlSyNmgzni7escoy9-gzGzoHsz',
      'X-LC-Key': 'i3EcxCSjfFeljEjxgMdrkfXK',
      // 'authorization':''
    };
    console.log(config);

    // if (config.isToken) {
    //   const token = 'xxxxx';
    //   if (token) {
    //     config.headers.Authorization = token;
    //   }
    // }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    console.log(response);
    if (response.status === 200) {
      return response.data;
    } else {
      return Promise.reject(response.data.message);
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求';
          break;
        case 401:
          error.message = '登录失效'
          break;
        case 403:
          error.message = '暂无权限,拒绝访问';
          break;
        case 404:
          error.message = '请求错误,未找到该资源';
          break;
        case 405:
          error.message = '请求方法未允许';
          break;
        case 408:
          error.message = '请求超时，请稍后重试或者刷新一下网页！';
          break;
        case 500:
          error.message = '服务器端出错，请稍后重试或者刷新一下网页！';
          break;
        case 501:
          error.message = '网络未实现';
          break;
        case 502:
          error.message = '网络错误';
          break;
        case 503:
          error.message = '服务不可用，请稍后重试或者刷新一下网页！';
          break;
        case 504:
          error.message = '网络超时';
          break;
        case 505:
          error.message = 'http版本不支持该请求';
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
      index.push(error.message);
    } else {
      if (JSON.stringify(error).includes('timeout')) {
        error.message = '连接服务器超时，请稍后重试或者刷新一下网页！';
      } else {
        error.message = '连接服务器失败，请稍后重试或者刷新一下网页！';
      }
      index.push(error.message);
    }
    message.error(error.message)
    return Promise.reject('');
  }
);
export default service;
